import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import AuditNotes from "@/components/audit/AuditNotes";
import { TableSkeleton } from "@/components/ui/Skeleton";
import { trpc } from "@/lib/trpc";
import { useAuditAccountId } from "./$orgSlug.audit";

// The Notes tab: the agents' side analyses and memory notes, each opening
// the Note page.
export const Route = createFileRoute("/_authenticated/$orgSlug/audit/notes")({
  component: NotesTab,
});

function NotesTab() {
  const { orgSlug } = Route.useParams();
  const accountId = useAuditAccountId();
  const { data } = useQuery(trpc.audit.notes.queryOptions({ orgSlug, accountId }));
  return data ? (
    <AuditNotes orgSlug={orgSlug} notes={data.notes} />
  ) : (
    <TableSkeleton label="Loading Notes" rows={6} columns={2} />
  );
}
